import { JsonMimeType } from "@lib/ApiClient";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import AddToCartResponseSchema from "@modules/cart/api_services/AjaxApiCartApiService/schemas/AddToCartResponseSchema";
import CartSchema from "@modules/cart/api_services/AjaxApiCartApiService/schemas/CartResponseSchema";
import { catchError, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { singleton } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

export interface AddToCartBodyInterface {
    items: { id: number; quantity: number }[];
}
@singleton()
export class AjaxApiCartApiService {
    constructor(
        private readonly apiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}
    getCart() {
        this.logger.debug("AjaxApiCartApiService.getCart is started");
        return this.apiClient
            .get({
                url: "/cart.js",
            })
            .pipe(
                map((v) => create(v.body, CartSchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "AjaxApiCartApiService.getCart is errored"
                    );
                    throw error;
                }),
                tap(() => {
                    this.logger.debug("AjaxApiCartApiService.getCart is ready");
                })
            );
    }
    addToCart(params: {
        items: { variantID: number; quantity: number }[];
        sections: string[];
    }) {
        this.logger.debug("AjaxApiCartApiService.addToCart is started", {
            items: params.items,
        });

        return this.apiClient
            .post({
                url: "/cart/add.js",
                body: JSON.stringify({
                    items: params.items.map((item) => ({
                        id: item.variantID,
                        quantity: item.quantity,
                    })),
                    sections: params.sections,
                }),
                contentType: JsonMimeType,
            })
            .pipe(
                map((v) => create(v.body, AddToCartResponseSchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "AjaxApiCartApiService.addToCart is errored",
                        {
                            items: params.items,
                        }
                    );
                    throw error;
                }),
                tap(() => {
                    this.logger.debug(
                        "AjaxApiCartApiService.addToCart is ready",
                        {
                            items: params.items,
                        }
                    );
                })
            );
    }
}
